export const STAT_TILE_BACKGROUND = '#F4F7F9'

export const statTileLabelStyles = {
  fontSize: '0.6875rem',
  fontWeight: 600,
  letterSpacing: '0.06em',
  lineHeight: 1.3,
  textTransform: 'uppercase',
  color: '#6B7C87',
}

export const statTileValueStyles = {
  fontSize: '1rem',
  fontWeight: 600,
  lineHeight: 1.3,
  color: '#00205B',
  wordBreak: 'break-word',
}

/**
 * Flat tinted stat tile used for small label-over-value metrics, shared by the
 * student details stats and Coach Analytics stat cards.
 */
export const statTileStyles = theme => ({
  statCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.75),
    padding: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: STAT_TILE_BACKGROUND,
    minHeight: 72,
    boxSizing: 'border-box',
  },
  statLabel: statTileLabelStyles,
  statValue: statTileValueStyles,
})
